import type { LlmAdapter } from "../types.js";

export interface ClaudeAdapterOptions {
  apiKey?: string;
  model?: string;
}

export class ClaudeAdapter implements LlmAdapter {
  private apiKey: string;
  private model: string;

  constructor(options: ClaudeAdapterOptions = {}) {
    this.apiKey = options.apiKey ?? process.env.ANTHROPIC_API_KEY ?? "";
    this.model = options.model ?? "claude-sonnet-4-6";
    if (!this.apiKey) {
      throw new Error(
        "ANTHROPIC_API_KEY environment variable is required for the claude adapter.",
      );
    }
  }

  async analyze(prompt: string): Promise<string> {
    const { default: Anthropic } = (await import("@anthropic-ai/sdk")) as {
      default: new (opts: { apiKey: string }) => AnthropicClient;
    };
    const client = new Anthropic({ apiKey: this.apiKey });
    const response = await client.messages.create({
      model: this.model,
      max_tokens: 4096,
      messages: [{ role: "user", content: prompt }],
    });
    return (response.content as Array<{ type: string; text?: string }>)
      .filter((b) => b.type === "text")
      .map((b) => b.text ?? "")
      .join("");
  }
}

interface AnthropicClient {
  messages: {
    create(opts: {
      model: string;
      max_tokens: number;
      messages: Array<{ role: string; content: string }>;
    }): Promise<{ content: Array<{ type: string; text?: string }> }>;
  };
}
